import { Component, Input } from '@angular/core';
import { ResolutionBreakpoint } from '../../classes/ResolutionBreakpoints';

@Component({
	selector: 'app-contained-progress-bar',
	templateUrl: './contained-progress-bar.component.html',
	styleUrls: ['./contained-progress-bar.component.scss']
})
export class ContainedProgressBarComponent {
	
	@Input() show! : boolean;
	@Input() underTableHeader = false;
	@Input() breakpointAt! : ResolutionBreakpoint;
	@Input() classes = ""; // Solo globales, porque las clases definidas en otro componente no van a ser accesibles desde este componente

}